export function uiid() {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let randomPart = ''
  for (let i = 0; i < 6; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length))
  }

  // Lấy 6 ký tự cuối của timestamp (tính bằng ms) để tiết kiệm độ dài
  const timePart = Date.now().toString(36).slice(-6)

  return timePart + randomPart // tổng = 12 ký tự
}

